import {Component} from "../Components/Component";
import {createLogger} from "../util/logger";
import {FormGroup} from "../core/FormGroup";
import {createFormError, createFormInfo, hideFormInfo, showFormInfo} from "../util/form";
import {RepeatInput} from "../Components/RepeatInput";
import {prefetchInvalidate} from "../util/prefetch";

const console = createLogger("EventPage");

export class EventPage extends Component {
    static name = "event-page";

    get name() {
        return EventPage.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement}
         */
        this.$registrationOverlay = this.$("registrationOverlay");

        /**
         * @type {HTMLFormElement}
         */
        this.$registrationForm = this.$("registrationForm");

        /**
         * @type {HTMLElement}
         */
        this.$registrationFormFooter = this.$("registrationFormFooter");

        /**
         * @type {HTMLElement}
         */
        this.$formSuccessMessage = this.$("formSuccessMessage");

        /**
         * @type {HTMLElement}
         */
        this.$formSuccessTitle = this.$("formSuccessTitle");

        /**
         * @type {FormGroup[]}
         */
        this.$formGroups = this.querySelectorAll(".form-group").map(group => new FormGroup(group));

        /**
         * @type {HTMLElement}
         */
        this.$btnBack = this.$("btnBack");

        /**
         * @type {HTMLElement|null}
         */
        this.$btnParticipate = this.$("btnRegister");

        this.$formError = createFormError("");
        this.$formErrorMessage = this.$formError.querySelector(".form-info__message");

        this.$formInfo = createFormInfo("");
        this.$formInfoMessage = this.$formInfo.querySelector(".form-info__message");

        this.$registrationForm.insertBefore(this.$formInfo, this.$registrationFormFooter);
        this.$registrationForm.insertBefore(this.$formError, this.$registrationFormFooter);

        if (this.$btnParticipate) {
            this.addEventListener(this.$btnParticipate, "click", this.onClickParticipate.bind(this));
        }

        this.addEventListener(this.$btnBack, "click", this.onClickBack.bind(this));

        this.addEventListener(this.$registrationForm, "submit", this.onSubmitForm.bind(this));
    }

    /**
     * @param {MouseEvent} e
     */
    onClickParticipate(e) {
        e.preventDefault();

        console.log("onClickparticipate");

        this.el.classList.add("event-page--registration-visible");
    }

    onClickBack(e) {
        this.el.classList.remove("event-page--registration-visible");
    }

    /**
     * @param {SubmitEvent} e
     */
    onSubmitForm(e) {
        e.preventDefault();

        if (this._pending) return;
        this._pending = true;
        this.$registrationForm.classList.add("form--pending");

        hideFormInfo(this.$formError);
        hideFormInfo(this.$formInfo);

        const data = new FormData(e.target);

        data.append("action", "create_participant");

        fetch(e.target.action, {
            method: "post",
            body: data,
            credentials: "include",
        }).then((res) => {
            console.log("submitForm response", res);
            return res.json();
        }).then((res) => {
            console.log("submitForm response.json", res);

            if (res.message) {
                if (res.title) {
                    this.$formSuccessTitle.innerText = res.title;
                }

                this.$formSuccessMessage.innerText = res.message;

                this.el.classList.add("event-page--registration-complete");
                this.resetForm();

                // Invalidate prefetch for events pages
                prefetchInvalidate(`${window.location.origin}/events`);
                prefetchInvalidate(`${window.location.origin}${window.location.pathname}`);

                return this.showFormInfo(res.message);
            }

            this.showFormError(res.error.message);

            if (res.error.details) {
                this.$formGroups.forEach((group) => {
                    if (!res.error.details[group.name]) return;

                    group.showError(res.error.details[group.name]);
                });
            }
        }).finally(() => {
            this._pending = false;
            this.$registrationForm.classList.remove("form--pending");
        });
    }

    /**
     *
     * @param {string} message
     */
    showFormError(message) {
        showFormInfo(this.$formError, message);
    }

    showFormInfo(message) {
        showFormInfo(this.$formInfo, message);
    }

    resetForm() {
        this.$registrationForm.reset();

        this.$registrationForm.querySelectorAll(RepeatInput.getModuleSelector()).forEach(el => {
            RepeatInput.create(el).reset();
        });
    }

}
